import { DAPI_HOST } from '../../config/index';

const getReviewPostUrl = () => `${DAPI_HOST}/v1/solv-ratings`;
const getNpsPostUrl = () => `${DAPI_HOST}/v1/nps`;

export { getReviewPostUrl, getNpsPostUrl };
